export enum DeploymentClass {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E'
}

export const deploymentClasses = Object.values(DeploymentClass);
